export const ADVERTISE_NOW_ROUTE = "/advertise-property";

export const BANNER_COLORS = {
  accent: "#00A870",
  accentDark: "#008A5C",
  accentLight: "#E6F4EF",
  neutralWhite: "#FFFFFF",
  neutralGray100: "#F5F5F5",
  neutralGray300: "#E0E0E0",
  neutralGray600: "#757575",
  neutralGray900: "#212121",
} as const;
export const BANNER_COPY = {
  title: "Anuncie seu imóvel",
  description:
    "Alugue com a 7Cantos de forma rápida, segura e sem burocracia.",
  ctaLabel: "Anunciar Agora",
} as const;

export const BANNER_BENEFITS = [
  { id: "free", label: "Grátis para anunciar", shortLabel: "Grátis" },
  { id: "visits", label: "500+ visitas por mês", shortLabel: "500+ visitas" },
  { id: "no-bureaucracy", label: "Sem burocracia", shortLabel: "Sem burocracia" },
] as const;

export const ANALYTICS_PLACEMENT = "banner_option_2";
